import React from "react"
import { Input, Typography, Space, Button, Tooltip } from "antd"
import { ClearOutlined } from "@ant-design/icons"

const { TextArea } = Input
const { Text } = Typography

export interface PatternTestInputProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
}

export const PatternTestInput: React.FC<PatternTestInputProps> = ({
  value,
  onChange,
  placeholder = "Paste your error message or any text you want to test against the blacklist patterns...",
}) => {
  const handleClear = () => {
    onChange("")
  }

  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Text strong>Test String</Text>
        <Space>
          {value && (
            <Tooltip title="Clear input">
              <Button
                type="text"
                size="small"
                icon={<ClearOutlined />}
                onClick={handleClear}
              />
            </Tooltip>
          )}
        </Space>
      </div>

      <TextArea
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        rows={4}
        style={{ fontSize: 12, fontFamily: "monospace" }}
      />

    </Space>
  )
}
